function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M18.75 22a3.25 3.25 0 100-6.5 3.25 3.25 0 000 6.5zM19 8a3 3 0 100-6 3 3 0 000 6zM5 8a3 3 0 100-6 3 3 0 000 6z"
}), /*#__PURE__*/React.createElement("path", {
  opacity: ".4",
  d: "M4.83 8.02a6.929 6.929 0 006.54 4.65h.03l3.53-.01c1.52-.02 2.88 1.01 3.29 2.49V17a.76.76 0 101.52 0V5.78a.76.76 0 10-1.52 0v6.62a4.941 4.941 0 00-3.28-1.26h-.02l-3.53.01h-.02c-2.29 0-4.34-1.45-5.09-3.62a.76.76 0 00-.72-.51c-.08 0-.17.01-.25.04-.41.12-.62.56-.48.96z"
})));